export default __webpack_public_path__ + "static/media/icon-reglage.8bcf82be.svg";